import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./AdvantagesBanner.module.scss";
import {getShopId} from "../getShopId";
import {getReturnPolicyDays} from "../../../helpers/getReturnPolicyDays";

/* --Desktop List-Version-- */
const AdvantagesBannerDesktop: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.listWrapper}>
      <ul>
        {!!getReturnPolicyDays() && (
          <li>
            <span className="icon icon-check--lightgreen" />
            {t("general.returnPolicy--days", {days: getReturnPolicyDays()})}
            {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
          </li>
        )}
        <li>
          <span className="icon icon-check--lightgreen" />
          {t("general.originalDesignBrands")}
          {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
        </li>
        <li>
          <span className="icon icon-check--lightgreen" />
          {t("general.24000products--cnt", {cnt: Intl.NumberFormat([]).format(24000)})}
        </li>
      </ul>
    </div>
  );
};

export default AdvantagesBannerDesktop;
